<template>
    <v-card class="mt-3 pa-0 elevation-0 no-background" >
    <v-flex px-4 >
     <v-card-title class="ma-0 mb-2 pa-0">
        <h3>Run a task</h3>
      </v-card-title>
      <v-card-text class="ma-0 mb-1 pa-0">
        <p>Task runs on every case in the {{bucketName}} bucket unless you select specific cases via the checkboxes.</p>
      </v-card-text>
      <v-layout xs12 wrap row>
      <v-flex xs12 sm6 md4 :class="{'mr-0 ': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.smAndUp}">
        <v-select
          :items="tasklistNames"
          :disabled="!tasklists"
          label="Tasklist"
          v-model="selectedTasklist"
          item-text="name"
          item-value="id"
          box>
        </v-select>
        </v-flex>
        <v-flex sm6 md4>
        <v-select
          :items="taskNames"
          :disabled="!tasklists"
          label="Task"
          v-model="selectedTask"
          item-text="description"
          item-value="id"
          box>
        </v-select>
      </v-flex>
      </v-layout>
      <v-card-actions class="ma-0 mb-4 pa-0">
        <v-btn
          :disabled="selectedTask === ''"
          @click="performUpdateTask()"
          id="bucket-update-dialog-confirm-btn"
          color="secondary">
        Run task</v-btn>
        <!--
        <v-btn
          @click="clearUpdateSelections()"
          id="bucket-update-dialog-cancel-btn"
          color="error">
        Cancel</v-btn>-->
      </v-card-actions>
      </v-flex>
      <v-divider class="mb-0"></v-divider>
    </v-card>

</template>

<script>
import { mapState } from 'vuex'
import Helpers from '@/helpers.js'

export default {
  props: {
    showRunTasksDialog: { type: Boolean },
    selections: { type: Array },
    caseTypeId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    selectedTasklist: "",
    selectedTask: "",
    tasklists: [],
    tasks: []
  }),
  computed: {
    ...mapState({
      bucket: state => state.buckets && state.buckets.current.bucket ? state.buckets.current.bucket : ""
    }),
    bucketName() {
      return this.bucket.name
    },
    tasklistNames() {
      if (this.tasklists.length > 0) {
        return this.tasklists.map(item => item.name)
      } else {
        return []
      }
    },
    taskNames() {
      if (this.tasks.length > 0) {
        return this.tasks.map(item => item.description)
      } else {
        return []
      }
    },
    hasSelections() {
      return this.selections.length > 0
    }
  },
  watch: {
    showRunTasksDialog() {
      if (this.showRunTasksDialog) { this.getTasklists() }
    },
    selectedTasklist() {
      this.tasklists.forEach(tasklist => {
        if (tasklist.name === this.selectedTasklist) { this.tasks = tasklist.tasks }
      })
    }
  },
  mounted() {
    this.getTasklists()
  },
  methods: {
    async getTasklists() {
      const caseType = await Helpers.getCaseTypeById(this.$store.state, this.caseTypeId)
      if (caseType) { this.tasklists = caseType.tasklistTemplates }
    },
    performUpdateTask() {
      const selectedTasklist = this.tasklists.find(tl => tl.name === this.selectedTasklist)
      if (selectedTasklist) {
        const task = selectedTasklist.tasks.find(t => t.description === this.selectedTask)
        if (this.hasSelections) {
          this.$store.dispatch("executeSelectedCaseRunTask", { task, caseIds: this.selections })
        } else {
          this.$store.dispatch("executeBucketRunTask", { task, bucket: this.bucket })
        }
      }
      this.clearUpdateSelections()
    },
    clearUpdateSelections() {
      this.selectedTasklist = ""
      this.selectedTask = ""
      this.showUpdateDialog = false
      this.$emit("tasks-dialog-closed")
    }
  }
}
</script>
